module.exports = __webpack_public_path__ + "static/media/cq_calcola b.06886250.svg";